import { BottomSheetExtendedProps } from '@betty/navigation';
import { OnboardingStep } from '../../state/onboarding.types';

export enum OnboardingAction {
  OPEN_CHAT = 'OPEN_CHAT',
  OPEN_ONFIDO = 'OPEN_ONFIDO',
  OPEN_DEPOSIT = 'OPEN_DEPOSIT',
}

export type OnboardingBottomSheetProps = BottomSheetExtendedProps & {
  step: OnboardingStep;
};
